import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import SectionSubHeader from "../sectionSubHeader";
import SectionHeader from "../sectionHeader";
import CustomButton from "../CustomButton";
import { Link, useNavigate } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";

const Impacts = () => {
  const navigate = useNavigate()
  return (
    <div className="section-bg impacts">
      <Row>
      <Col lg={3}>
        <img src="./images/impact1.png" alt="gallery img" />
      </Col>
          <Col lg={6} className="text-center">
           <SectionHeader mainText1="Making a Global & Local Impact"  />
            <SectionSubHeader headerText="Volto's" />
            <h1>30+</h1>
            <SectionSubHeader headerText="year history is unique." />
            <p>Join our diverse, inclusive team for a career with impact—meaningful work, accelerated growth, and the chance to make a difference from day one!</p>
            <CustomButton buttonText="View Gallery" buttonType="FooterBtn" arrow  onClick={()=> navigate('/gallery')} />
          </Col>
          <Col lg={3}> 
            <img src="./images/impact2.png" alt="gallery img" />
          </Col>
        </Row>
    </div>
  );
};

export default Impacts;
